import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import TkTitle from "../../../../atoms/TkTitle";
import TkButton from "../../../../atoms/TkButton";
import { transposedHiragana } from "../../../../../assets/data/Constants";
import "./_style.scss";
import { TkSelectForm } from "../../../../atoms/TkSelectForm";
import { TkBankSelectionContext } from "../../context";
import { httpGetBranch } from "../../api/request";
import { banks } from "../../../../../assets/data/Constants";
import { isMobileDevice } from "../../../../../utils/useTools";
import _ from "lodash";
import TkLabelText from "../../../../atoms/TkLabelText";

/**
 * 銀行支店の選択コンポーネント
 *
 * @props
 * - なし
 */
const BranchSelection: React.FC = () => {
  const [selectBank, setSelectBank] = React.useState<any[]>([]);
  const [selectedBankCode, setSelectedBankCode] = React.useState<string>("");
  const [currentHiragana, setCurrentHiragana] = React.useState<string | null>(
    null
  );

  const { state, setState } = useContext(TkBankSelectionContext);

  // スマホ判断
  const isMobile = isMobileDevice();
  const [mobileErrorMessggess, setMobileErrorMessggess] = useState<any>("");
  const mobileInputRef = useRef<string>("");
  const mobileInputDebounce = useRef(
    _.debounce((e: any) => {
      handleMobileSearch(e);
    }, 200)
  );

  // 濁音・半濁音の変換
  const SeionEnum = Object.freeze({
    が: "か",
    ぎ: "き",
    ぐ: "く",
    げ: "け",
    ご: "こ",
    ざ: "さ",
    じ: "し",
    ず: "す",
    ぜ: "せ",
    ぞ: "そ",
    だ: "た",
    ぢ: "ち",
    づ: "つ",
    で: "て",
    ど: "と",
    ば: "は",
    び: "ひ",
    ぶ: "ふ",
    べ: "へ",
    ぼ: "ほ",
    ぱ: "は",
    ぴ: "ひ",
    ぷ: "ふ",
    ぺ: "へ",
    ぽ: "ほ",
  });

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    if (state.selectBranchValue) {
      const res = await httpGetBranch({
        branchNameKana: state.selectBranchValue,
        bankCd: state.bankCode || "",
      });
      res?.branchList && res?.branchList.length
        ? setSelectBank(
            res?.branchList.map((bank) => {
              return {
                value: bank.branchCd,
                label: bank.branchName,
                kana: bank.branchNameKatakana,
              };
            })
          )
        : setSelectBank([]);
      setSelectedBankCode(state.branchCode ? state.branchCode : "");
      setCurrentHiragana(state.selectBranchValue);
    }
  };

  useEffect(() => {
    const selBank = selectBank.find((bank) => bank.value === selectedBankCode);
    if (!selBank) return;

    const selBankNew = {
      branchCode: selBank.value,
      branchName: selBank.label,
      branchNameKatakana: selBank.kana,
    };

    setState({
      ...state,
      ...selBankNew,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBankCode]);

  const handleOnGetValue = (event: any) => {
    setSelectedBankCode(event);
  };

  const handleOnSearchValue = async (event?: any, other?: boolean) => {
    try {
      setCurrentHiragana(event);

      if (other) {
        const filteredBanks = banks.filter((bank) =>
          /^[A-Za-z]/.test(bank.bankName)
        );
        setSelectBank(
          filteredBanks.map((bank) => {
            return {
              value: bank.bankCode,
              label: bank.bankName,
              kana: bank.bankNameKatakana,
            };
          })
        );
      }

      const res = await httpGetBranch({
        branchNameKana: event,
        bankCd: state.bankCode || "",
      });

      res?.branchList && res?.branchList.length
        ? setSelectBank(
            res?.branchList.map((bank) => {
              return {
                value: bank.branchCd,
                label: bank.branchName,
                kana: bank.branchNameKatakana,
              };
            })
          )
        : setSelectBank([]);
    } catch (error) {
      console.error(error);
    }
  };

  const convertToSeion = (char: string) => {
    if (char in SeionEnum) {
      return SeionEnum[char as keyof typeof SeionEnum];
    }
    return char;
  };

  const handleMobileSearch = (e: any) => {
    const returnValue = e.target.value;
    if (returnValue === mobileInputRef.current) return;

    if (returnValue === "") {
      mobileInputRef.current = "*";
      setMobileErrorMessggess("");
      return;
    }

    mobileInputRef.current = returnValue;

    const hiraganaPattern = /^[\u3040-\u309F]+$/;

    if (hiraganaPattern.test(returnValue)) {
      setMobileErrorMessggess("");
      mobileInputRef.current = convertToSeion(returnValue);
    } else {
      setMobileErrorMessggess("ひらがな1文字で入力してください");
    }
  };

  return (
    <Box className="financialInstitutionSelection">
      <Box className="title">
        <TkTitle size="large">{state.bankName}</TkTitle>
      </Box>
      <TkTitle size="medium" className="titleForSearch">
        支店検索
      </TkTitle>

      {!isMobile && (
        <>
          <TkTitle size="medium">
            支店名の頭文字を選択してください。　例：横浜支店→「よ」をクリック
          </TkTitle>
          <Box className="button">
            {transposedHiragana.map((hiragana, hIndex) => {
              return hiragana.map((item, index) => {
                return (
                  <TkButton
                    onClick={() => item && handleOnSearchValue(item)}
                    className="hina"
                    variant={
                      currentHiragana === item ? "outlined" : "contained"
                    }
                    key={`${hIndex}-${index}`}
                  >
                    {item ? item : "　"}
                  </TkButton>
                );
              });
            })}
            <TkButton
              className="other"
              onClick={() => handleOnSearchValue("*", true)}
              variant={currentHiragana === "*" ? "outlined" : "contained"}
            >
              その他
            </TkButton>
          </Box>
        </>
      )}

      {/* スマホ */}
      {isMobile && (
        <Box className="phoneBord">
          <TkTitle className="title" size="medium">
            支店名の頭文字をひらがなで入力して「検索」ボタンを押してください。
          </TkTitle>

          <Box className="searchInput">
            <Box className="kanaSec">
              <TkLabelText
                className="kanaInput"
                inputProps={{ maxLength: 1 }}
                onChange={(e) => mobileInputDebounce.current(e)}
                error={!!mobileErrorMessggess}
                helperText={mobileErrorMessggess}
              ></TkLabelText>
              <TkButton
                onClick={() => {
                  if (mobileErrorMessggess) return;
                  if (mobileInputRef.current === "") {
                    mobileInputRef.current = "*";
                  }
                  if (mobileInputRef.current.length > 1) return;
                  handleOnSearchValue(
                    mobileInputRef.current,
                    mobileInputRef.current === "*"
                  );
                }}
              >
                検索
              </TkButton>
            </Box>

            <Box>件数：{selectBank.length}件</Box>
          </Box>
          <Box>
            <Typography>
              ※支店名が英字から始まる場合は、空欄のまま「検索」ボタンを押してください。
            </Typography>
          </Box>
        </Box>
      )}

      <Box className={`${!isMobile ? "select" : "select mobile"}`}>
        <TkTitle className="title" size="medium">
          {!isMobile
            ? "支店を選択して「選択」ボタンをクリックしてください。"
            : "支店を選択して「選択」ボタンを押してください。"}
        </TkTitle>
        <TkSelectForm
          wantToSetValue={selectedBankCode}
          onGetValue={handleOnGetValue}
          minW="250px"
          variant="outlined"
          selectPropsList={selectBank}
          disabled={!(Array.isArray(selectBank) && selectBank.length !== 0)}
        />
      </Box>

      <Box className="moveButton">
        <TkButton
          size="large"
          onClick={() => {
            setState({
              ...state,
              step: 0,
            });
          }}
        >
          戻る
        </TkButton>
        <TkButton
          disabled={!selectedBankCode}
          onClick={() => {
            setState({
              ...state,
              step: 2,
              selectBranchValue: currentHiragana ? currentHiragana : "*",
            });
          }}
          size="large"
          ml
        >
          選択
        </TkButton>
      </Box>
    </Box>
  );
};

export default BranchSelection;
